import { ModalWidth } from '@/config';
import { Modal, Spin, Timeline } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownCircleFilled, StopFilled } from '@ant-design/icons';
import { RouteDto, RouteStopDto } from '@/__generated';
import { apiSdk } from '@/httpClient';
type Props = {
  route: RouteDto;
  onClose: () => void;
};

export default function StopDetailModal({ route, onClose }: Props) {
  const { t } = useTranslation();
  const [stops, setStops] = React.useState<RouteStopDto[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  React.useEffect(() => {
    if (route?.id) {
      setLoading(true);
      apiSdk.RouteService.getRouteStops({ routeId: route.id })
        .then(res => {
          setStops(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [route]);
  return (
    <Modal
      okButtonProps={{ style: { display: 'none' } }}
      cancelText={t('Close')}
      onCancel={v => onClose()}
      open={true}
      width={ModalWidth.small}
      title={t('routesPage_RouteStops')}
    >
      <Spin spinning={loading}>
        <Timeline mode={'right'}>
          <Timeline.Item dot={<DownCircleFilled style={{ fontSize: 20 }} />}>{route.originStation}</Timeline.Item>
          {stops.map(stop => {
            return <Timeline.Item label={`${stop.distanceFromSource}Kms`}>{stop.stationName}</Timeline.Item>;
          })}

          <Timeline.Item dot={<StopFilled style={{ fontSize: 20, color: '#cf1322' }} />}>{route.destinationStation}</Timeline.Item>
        </Timeline>
      </Spin>
    </Modal>
  );
}
